import { TextInput as Input } from "@frends/ui-components/react";
import type { InputRef } from "@frends/ui-components/react/types/TextInput";

export default Input;
export type { InputRef };
